<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <!-- 스펙104: 좌측 상단 = 후원인/추천인 설정해제, 우측 상단 = 저장/취소 -->
      <div class="head">
        <button class="mini warn" :disabled="!canEdit" @click="unsetSponsor">후원인 설정해제</button>
        <button class="mini warn" :disabled="!canEdit" @click="unsetReferrer">추천인 설정해제</button>
        <span class="spacer"></span>
        <button class="primary" :disabled="!canEdit || busy" @click="doSaveClose">저장</button>
        <button class="ghost" @click="close">취소</button>
      </div>
      <div class="titlebar">고객 정보 수정 <small>{{ self.loginId }} ({{ self.name }})</small></div>

      <div class="body">
        <!-- 스펙104: 후원인 = 내 부모(단일). 본문에는 수정 버튼만 -->
        <div class="row">
          <div class="cap">후원인</div>
          <div class="val">
            <span class="who">{{ label(local.sponsorName, local.sponsorLogin) }}</span>
            <button class="mini" :disabled="!canEdit" @click="openSponsor">수정</button>
          </div>
        </div>

        <!-- 스펙104: 추천인 = 내 추천(단일). 본문에는 수정 버튼만 -->
        <div class="row">
          <div class="cap">추천인</div>
          <div class="val">
            <span class="who">{{ label(local.referrerName, local.referrerLogin) }}</span>
            <button class="mini" :disabled="!canEdit" @click="openReferrer">수정</button>
          </div>
        </div>

        <!-- 추천매칭 광고캐시백 정산 대수 -->
        <div class="row">
          <div class="cap">추천매칭 광고캐시백 정산 대수</div>
          <div class="val"><b>{{ matchingGen }}</b> 대 <span class="muted">(직급: {{ rankName || '그린스타' }})</span></div>
        </div>

        <!-- 소속 센터 -->
        <div class="row">
          <div class="cap">소속 센터</div>
          <div class="val">
            <span class="who">{{ local.centerName || '-' }}</span>
            <button class="mini" :disabled="!canEdit" @click="centerOpen=true">수정</button>
          </div>
        </div>
      </div>

      <p v-if="pending.length" class="info">저장 대기 중인 변경 {{ pending.length }}건이 있습니다. [저장]을 눌러야 반영됩니다.</p>
      <p v-if="message" :class="error ? 'error' : 'info'">{{ message }}</p>
    </div>

    <SearchDialog v-if="searchOpen" @select="onSearchSelect" @close="closeSearch" />
    <CenterSearchDialog v-if="centerOpen" @select="onCenterSelect" @close="centerOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import { getAuth } from '../store/auth';
import SearchDialog from './SearchDialog.vue';
import CenterSearchDialog from './CenterSearchDialog.vue';

export default {
  name: 'CustomerEditDialog',
  components: { SearchDialog, CenterSearchDialog },
  props: { owner: { type: Object, required: true } },
  data() {
    return {
      self: Object.assign({}, this.owner),
      // 화면 표시용 로컬 상태(저장 전까지 DB 미반영)
      local: { sponsorName: '', sponsorLogin: '', referrerName: '', referrerLogin: '',
               centerId: null, centerName: '' },
      rankName: '', matchingGen: 0,
      // 저장 대기 명령 큐 (저장 눌러야 실행)
      pending: [],
      searchOpen: false, centerOpen: false,
      searchMode: '',        // 'sponsor' | 'referrer'
      message: '', error: false, busy: false,
      canEdit: getAuth().role !== 'customer'     // customer 권한은 취소(닫기) 외 비활성화 (staff·admin 편집 가능)
    };
  },
  created() { this.loadAll(); },
  computed: {
    // 스펙234_개선_35: knomad 로그인id 로 수정 팝업에 들어온 경우 후원인 수정 불가
    sponsorLocked() { return (this.self && this.self.loginId) === 'knomad'; }
  },
  methods: {
    label(name, login) {
      if (!login && !name) return '-';
      return (name || '') + (login ? '(' + login + ')' : '');
    },
    async loadAll() {
      this.message = '';
      try {
        // 스펙102: 후원인(부모)·추천인(추천)·센터·직급 한 번에 조회
        const res = await api.editInfo(this.owner.id);
        const dd = res.data || {};
        this.rankName = dd.rankName;
        this.matchingGen = dd.matchingGen || 0;
        this.self = Object.assign({}, this.owner, { loginId: dd.loginId, name: dd.name });
        // 로컬 상태 초기화 (DB 실제 상태 스냅샷)
        this.local = {
          sponsorName: dd.sponsorName || '', sponsorLogin: dd.sponsorLogin || '',
          referrerName: dd.referrerName || '', referrerLogin: dd.referrerLogin || '',
          centerId: dd.centerId || null, centerName: dd.centerName || ''
        };
        this.pending = [];
      } catch (e) { this.error = true; this.message = e.message; }
    },
    // ----- 후원인(단일) 수정 : 스테이징(저장 시 반영) -----
    openSponsor() {
      // 스펙234_개선_35: knomad 는 후원인 수정 불가 → 버튼은 활성, 클릭 시 메시지 박스
      if (this.sponsorLocked) { window.alert('이 사용자는 후원인을 수정할 수 없습니다.'); return; }
      this.searchMode = 'sponsor'; this.searchOpen = true;
    },
    // 스펙104: 설정 해제는 수정과 달리 "즉시 실행". 성공 시 바로 팝업 닫기, 실패 시 사유를 팝업 내 표시.
    async unsetSponsor() {
      if (!this.canEdit || this.busy) return;
      // 스펙234_개선_35: knomad 는 후원인 설정해제 불가 → 클릭 시 메시지 박스
      if (this.sponsorLocked) { window.alert('이 사용자는 후원인을 수정할 수 없습니다.'); return; }
      if (!window.confirm('후원인 설정 해제하시겠습니까?')) return;
      this.busy = true; this.message = '';
      try {
        await api.sponsorUnset({ customerId: this.owner.id, actor: getAuth().loginId });
        this.$emit('saved');
        this.$emit('close');
      } catch (e) { this.fail(e); }
      finally { this.busy = false; }
    },
    // ----- 추천인(단일) 수정 : 스테이징(저장 시 반영) -----
    openReferrer() { this.searchMode = 'referrer'; this.searchOpen = true; },
    async unsetReferrer() {
      if (!this.canEdit || this.busy) return;
      if (!window.confirm('추천인 설정 해제하시겠습니까?')) return;
      this.busy = true; this.message = '';
      try {
        await api.referrerUnset({ customerId: this.owner.id, actor: getAuth().loginId });
        this.$emit('saved');
        this.$emit('close');
      } catch (e) { this.fail(e); }
      finally { this.busy = false; }
    },
    // ----- 공통 회원 검색 결과 처리 (스테이징만) -----
    onSearchSelect(sel) {
      this.searchOpen = false;
      if (this.searchMode === 'sponsor') {
        this.local.sponsorName = sel.name; this.local.sponsorLogin = sel.loginId;
        this.pending.push({ kind: 'sponsorSet', targetLoginId: sel.loginId });
      } else if (this.searchMode === 'referrer') {
        this.local.referrerName = sel.name; this.local.referrerLogin = sel.loginId;
        this.pending.push({ kind: 'referrerSet', targetLoginId: sel.loginId });
      }
      this.searchMode = '';
    },
    closeSearch() { this.searchOpen = false; this.searchMode = ''; },
    // ----- 센터 (스테이징만) -----
    onCenterSelect(c) {
      this.centerOpen = false;
      // 센터 검색 결과 필드명은 centerName (name 아님).
      this.local.centerId = c.id;
      this.local.centerName = c.centerName || c.name || '';
      this.pending.push({ kind: 'center', centerId: c.id });
    },
    info(m) { this.error = false; this.message = m; },
    fail(e) { this.error = true; this.message = (e && e.message) ? e.message : String(e); },
    // ----- 저장 : "저장하시겠습니까?" 확인 후 큐 실행 -----
    async doSaveClose() {
      if (!this.canEdit) { this.$emit('close'); return; }
      if (this.pending.length === 0) { this.$emit('close'); return; }
      if (!window.confirm('저장하시겠습니까?')) return;
      const actor = getAuth().loginId;
      const customerId = this.owner.id;
      this.busy = true; this.message = '';
      try {
        for (const cmd of this.pending) {
          if (cmd.kind === 'sponsorSet') {
            await api.sponsorSet({ customerId: customerId, sponsorLoginId: cmd.targetLoginId, actor: actor });
          } else if (cmd.kind === 'referrerSet') {
            await api.referrerSet({ customerId: customerId, referrerLoginId: cmd.targetLoginId, actor: actor });
          } else if (cmd.kind === 'center') {
            await api.centerSave({ customerId: customerId, centerId: cmd.centerId, actor: actor });
          }
        }
        this.pending = [];
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        // 일부 반영되었을 수 있으므로 실제 상태를 먼저 다시 읽고,
        // 그 다음에 실패 사유를 표시한다. (loadAll 이 message 를 초기화하므로 순서 중요)
        await this.loadAll();
        this.fail(e);
      } finally { this.busy = false; }
    },
    // 취소/닫기 : 대기중 변경 폐기(DB 미반영)
    close() { this.$emit('close'); }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 60; }
.modal { background: #fff; padding: 20px 22px; border-radius: 8px; width: 660px; max-width: 96vw; max-height: 92vh; overflow: auto; }
.head { display: flex; align-items: center; gap: 8px; padding-bottom: 10px; }
.head .spacer { flex: 1; }
.titlebar { border-bottom: 1px solid #eef; padding-bottom: 12px; margin-bottom: 14px; font-size: 15px; font-weight: 600; color: #1f2a44; }
.titlebar small { color: #888; font-weight: 400; font-size: 12px; margin-left: 6px; }
.head button { padding: 7px 16px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; }
.head .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head .primary:disabled { background: #9db8ef; }
.head .ghost { background: #f5f5f5; }
.row { display: flex; gap: 12px; padding: 10px 0; border-bottom: 1px dashed #eef; }
.cap { flex: 0 0 200px; color: #33415c; font-size: 13px; font-weight: 600; padding-top: 4px; }
.val { flex: 1; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.who { font-size: 13px; }
.muted { color: #999; font-size: 12px; }
.mini { padding: 3px 10px; font-size: 11px; background: #eef1f7; color: #2f6fed; border: 1px solid #cfdcff; border-radius: 4px; cursor: pointer; }
.mini.warn { background: #fff2f2; color: #c33; border-color: #f0c0c0; }
.mini:disabled { opacity: .5; cursor: not-allowed; }
.info { font-size: 13px; color: #2f6fed; margin: 10px 0 0; }
.error { font-size: 13px; color: #d93636; margin: 10px 0 0; }
</style>
